<template>
  <div>
    <van-field v-model="fieldValue" is-link readonly :placeholder="issue.placeholder" @click="show = true" />
    <van-popup v-model="show" round position="bottom">
      <van-cascader
        v-model="cascaderValue"
        title="请选择所在地区"
        :options="issue.groups"
        @close="show = false"
        @finish="onFinish"
        :field-names="fieldNames"
      />
    </van-popup>
    <div v-if="issue.levelsNum < issue.requiredNum" class="van-field-border mt-2">
      <van-field v-for="item in issue.items" :key="item.id" v-model="item.value" placeholder="详细地址" />
    </div>
    <div class="vote-answer vote-answering-wrapper" v-if="showVoteProgress">
      <template v-if="voteItems.length">
        <div style="margin-bottom: 12px">
          投票排名
        </div>
      </template>
      <choice-vote-content :items="voteItems"/>
      <template v-if="voteItems.length > 5">
        <van-button type="primary" size="small" block @click="onShowMoreRank">查看更多排名</van-button>
      </template>
    </div>
  </div>
</template>

<script>
import vote from './vote'
export default {
  name: 'Cascader',
  changeExpr: 'changeExpr',
  mixins:[vote],
  data() {
    return {
      fieldValue: '',
      show: false,
      cascaderValue: '',
      options: [],
      fieldNames: {
        text: 'content',
        value: 'id',
        children: 'nextLevelOptions'
      }
    }
  },
  methods: {
    onFinish({ selectedOptions }) {
      this.show = false
      this.fieldValue = selectedOptions.map(option => option.content).join('/')
      this.issue.value = selectedOptions.map(i => i.id)
    }
  },
  computed: {
    changeExpr() {
      return this.issue.value.join('-') + this.issue.items.map(i => i.value).join(',')
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.fieldValue = this.issue.inputValue
      this.cascaderValue = this.issue.value.slice().pop() || ''
    })
  }
}
</script>
